<template>
  <div class="select-nested-entities" ref="selectContainer">
    <div class="select-nested-entities__select" @click="showTree = !showTree" tabindex="0">
      <div class="select-nested-entities__chips" v-if="selectNavigationLinks.length">
        <v-chip
            v-for="(item, index) in selectedItems"
            :key="index"
            small
            close
            class="select-nested-entities__chip"
            @click:close="removeSelection(item)"
            color="#EDFCFB"
            close-icon="mdi-close"
            text-color="#62646A"
        >
          {{ item.label }}
        </v-chip>
      </div>
      <div class="select-nested-entities__placeholder" v-else>Select categories</div>
      <div class="select-nested-entities__actions">
        <v-icon
            v-if="selectNavigationLinks.length"
            size="16"
            class="select-nested-entities__actions-clear"
            @click.stop="clearAllSelections"
        >
          mdi-close
        </v-icon>
        <v-icon
            class="select-nested-entities__actions-toggle"
            :class="{ 'select-nested-entities__actions-toggle--rotated': showTree }"
        >
          mdi-chevron-down
        </v-icon>
      </div>
    </div>
    <v-card v-if="showTree" class="mt-2">
      <v-treeview
          v-model="selectNavigationLinks"
          :items="navigationLinks"
          item-key="id"
          item-text="label"
          selectable
          return-object
          open-all
          dense
          class="pa-3"
          selected-color="#00A86B"
      >
        <template v-slot:label="{ item }">
          {{ item.label }}
        </template>
      </v-treeview>
      <div
          class="select-nested-entities__clear"
          v-if="selectNavigationLinks.length"
          @click.prevent="clearAllSelections"
      >
        Clear
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'SelectNestedEntities',
  props: {
    navigationLinks: {
      type: Array,
      required: true,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    showTree: false,
    selectNavigationLinks: [],
  }),
  computed: {
    selectedItems() {
      return this.selectNavigationLinks || [];
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);

    if (this.value && this.value.length) {
      const allItems = this.getAllItems(this.navigationLinks);
      this.selectNavigationLinks = allItems.filter((item) => this.value.includes(item.id));
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    getAllItems(items) {
      let result = [];
      for (const item of items) {
        result.push(item);
        if (item.children && item.children.length) {
          result = result.concat(this.getAllItems(item.children));
        }
      }
      return result;
    },

    removeSelection(item) {
      const index = this.selectNavigationLinks.findIndex((i) => i.id === item.id);
      if (index >= 0) {
        this.selectNavigationLinks.splice(index, 1);
      }
    },
    clearAllSelections(event) {
      event.stopPropagation();
      this.selectNavigationLinks = [];
    },
    updateSelection() {
      const selectedIds = this.selectNavigationLinks.map((item) => item.id);
      this.$emit('input', selectedIds);
    },
    handleClickOutside(event) {
      const container = this.$refs.selectContainer;
      if (container && !container.contains(event.target) && this.showTree) {
        this.showTree = false;
      }
    },
  },
  watch: {
    selectNavigationLinks: {
      handler() {
        this.updateSelection();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.select-nested-entities {
  &__placeholder {
    font-size: 13px;
    font-weight: 600;
    color: #999999;
    font-style: italic;
  }

  &__select {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    border: 1px solid #d3d2d2;
    min-height: 40px;
    height: auto;
    padding: 0 8px;

    &:focus {
      border-color: #a7dad8;
    }

    &:hover {
      cursor: text;
    }
  }

  &__chips {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    flex: 1;
    align-items: center;
    overflow: hidden;
    padding: 7px 0;

    .mdi-close::before {
      font-size: 18px;
      color: #62646a;
    }
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 8px;

    &-clear {
      cursor: pointer;
      color: #62646a;
      opacity: 0;
      transition: opacity 0.2s ease;

      &:hover {
        color: #333;
      }
    }

    &-toggle {
      transition: transform 0.3s ease;

      &--rotated {
        transform: rotate(180deg);
      }

      &:hover {
        cursor: pointer;
      }

      &::before {
        font-size: 24px;
        color: #919191;
      }
    }
  }

  &:hover {
    .select-nested-entities__actions-clear {
      opacity: 1;
    }
  }

  &__clear {
    display: flex;
    align-items: center;
    padding: 12px 20px;
    cursor: pointer;
    font-size: 14px;
    color: #42b77a;
  }
}
</style>
